<div class="container">
  <div class="title">{{ title }}</div>
  <img [src]="src" [alt]="'common.alt-image' | transloco" />
  <div>{{ description }}</div>
</div>
